import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import cycle from "../../../assets/images/cycle.png";

const Categories = () => {
  return (
    <Box
      margin={{ xs: "25% 0% 15% 0%", sm: "5% 0% 10% 0%" }}
      data-aos={"fade-down"}
    >
      <Box>
        <Typography
          variant="h3"
          fontWeight={700}
          textAlign={"center"}
          paddingBottom={{ xs: "6%", sm: "4%" }}
          color={"#39484E"}
        >
          Strategic Investment Plan
        </Typography>

        <Box>
          <Box
            component="img"
            height={{ xs: "", sm: "1450px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={cycle}
            alt={"investment_plan_img"}
            sx={{
              objectFit: "cover",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Categories;
